import * as React from "react";
import { Route, RouteProps } from "react-router-dom";
import getJwtToken from "utils/getJwtToken";
import getBaseUrl from "../../utils/getBaseUrl";
import Unauthorized from "../account/Unauthorized";
import Layout from "./../Layout";
import { useAccount, useMsal } from "./msal";


interface Props extends RouteProps {
    component: React.ComponentClass<any>;
}

function isAuthenticated() {
    let token = getJwtToken();
    if (token === null) {
        return false;
    }

    if (new Date().getTime() >= token.exp * 1000) {
        return false;
    }

    return true;
}

const RouteWithLayout: React.FC<Props> = ({
    component: Component,
    ...rest
}) => {
    const { accounts } = useMsal();
    const account = useAccount(accounts[0] || {});

    const [authorized, setAuthorized] = React.useState<boolean | null>(null);

    React.useEffect(() => {
        async function checkAuthorization() {
            let token = localStorage.getItem("authorization_token");
            if (token === null && account !== null) {
                const url = `${getBaseUrl()}api/account/Token`;
                const username = account.username || account.name;

                if (!username) {
                    console.error('RouteWithLayout: No username or name available in MSAL account.', account);
                    setAuthorized(false);
                    return;
                }

                try {
                    const response = await fetch(url, {
                        method: 'POST',
                        headers: {
                            'Content-Type': 'application/json',
                        },
                        body: JSON.stringify({ UserName: username }),
                    });

                    if (!response.ok) {
                        if (response.status === 404) {
                            localStorage.removeItem("authorization_token");
                            setAuthorized(false);
                        } else {
                            console.error('RouteWithLayout: Token endpoint returned status', response.status);
                            setAuthorized(false);
                        }
                    } else {
                        const responseData = await response.json();

                        if (responseData !== null) {
                            localStorage.setItem("authorization_token", responseData.authorization_token);
                            setAuthorized(true);
                        }
                    }
                } catch (error) {
                    console.error('Error:', error);
                    setAuthorized(false);
                }
            } else {
                // User is authorized
                setAuthorized(true);
            }
        }

        checkAuthorization();
    }, [account]);

    if (authorized === null) {
        // Authorization check is in progress, you can show a loading spinner or message here
        return <div></div>;
    } else if (authorized) {
        // User is authorized, render Layout and Component
        return (
            <Route
                {...rest}
                render={(props) => (
                    <Layout {...props}>
                        <Component {...props} />
                    </Layout>
                )}
            />
        );
    } else {
        // User is not authorized, redirect to Unauthorized page
        return (
            <Route
                {...rest}
                render={(props) => {
                    return <Unauthorized {...props} />;
                }}
            />
        );
    }
};

export default RouteWithLayout;



// WEBPACK FOOTER //
// ./ClientApp/components/common/RouteWithLayout.tsx